module.exports = __webpack_public_path__ + "img/pc-film.007be76d.webp";